import React from 'react';
import {useNavigate} from 'react-router-dom';
import DataError from '../DataError/DataError';
import Activity from '../../helpers/Activity';
import Navigation from '../../config/Navigation';
import './NotFound.css';

function NotFound() {
    const navigate = useNavigate();

    const toHome = () => {
        Activity.log('not-found-view', 'scan-button', 'click', {error: 'S&G-not-found'});
        const url = Navigation.getHomeUrl();
        navigate(url);
    };

    return (
        <div className='not-found'>
            <DataError message='Lo sentimos, la página que estás intentando ver no existe' actionLabel='Escanear un producto' action={toHome} padding={20} maxWidth={undefined} iconSize={undefined} fontSize={undefined}/>
        </div>
    );
}

export default NotFound;